import { createSelector } from 'reselect';
import { defaultLocale } from '@synergy/config';

import { AppState } from '../../store/models/app-state';

const getUserLocale = (state: AppState) => state.user.locale;
const getCurrentLocale = (state: AppState) => state.currentLocale;

export const localesSelector = createSelector([getUserLocale, getCurrentLocale], (userLocale, currentLocale) => {
    return [...(userLocale ? [userLocale] : []), ...(currentLocale ? [currentLocale] : []), defaultLocale];
});

export const bestLocaleSelector = createSelector([localesSelector], locales => {
    return locales[0];
});
